import { render } from "./FleetVehicleDetail.vue?vue&type=template&id=7896cdac&scoped=true"
import script from "./FleetVehicleDetail.vue?vue&type=script&lang=js"
export * from "./FleetVehicleDetail.vue?vue&type=script&lang=js"

import "./FleetVehicleDetail.vue?vue&type=style&index=0&id=7896cdac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7896cdac"]])

export default __exports__